import React from 'react';
import { Typography, TextField, Stack, Alert, Button, Box } from '@mui/material';
import SettingsPageLayout from './SettingsPageLayout';

/** Security section; password updates are handled outside this form. */
const SecuritySettings = () => (
  <SettingsPageLayout
    title="Security"
    description="Protect your account. Use a strong, unique password and sign out on shared devices."
  >
    <Alert severity="info" sx={{ borderRadius: 1 }}>
      To change your password, use the Forgot password link on the login screen, or contact your firm admin if you
      use single sign-on.
    </Alert>
    <Typography variant="subtitle2" color="text.secondary" fontWeight={600}>
      Password
    </Typography>
    <Stack spacing={2} sx={{ width: '100%', maxWidth: 520 }}>
      <TextField type="password" label="Current password" fullWidth disabled size="small" helperText="Not editable here" />
      <TextField type="password" label="New password" fullWidth disabled size="small" />
      <TextField type="password" label="Confirm new password" fullWidth disabled size="small" />
      <Box>
        <Button variant="contained" disabled>
          Update password
        </Button>
      </Box>
    </Stack>
  </SettingsPageLayout>
);

export default SecuritySettings;
